import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useIsRestoring } from '@tanstack/react-query';
import { LoadingState } from '../components/States';
import { useMe } from '../features/auth/useAuth';
import { homeFor } from '../features/auth/RequireAuth';

export const Route = createFileRoute('/')({
  component: Index,
});

/** Роздоріжжя: дитину ведемо на арену, батька й глядача — у кабінет, гостя — на вхід. */
function Index(): React.JSX.Element {
  const navigate = useNavigate();
  const isRestoring = useIsRestoring();
  const me = useMe();
  const settling = isRestoring || (me.isPending && me.fetchStatus !== 'paused');

  useEffect(() => {
    if (settling) return;
    const role = me.data?.user.role;
    if (role) void navigate({ to: homeFor(role) });
    else void navigate({ to: '/login', search: { expired: false } });
  }, [settling, me.data?.user.role, navigate]);

  return <LoadingState />;
}
